<template>
  <v-select
      v-model="value"
      :items="items"
      item-text="name"
      item-value="id"
      :label="label"
      :clearable="clearable"
      :multiple="multiple"
      :return-object="!multiple"
      :disabled="disabled"
      hide-details
  >
    <template v-slot:selection="{ item, index }">
      <span v-if="index === 0">
        <span>{{ item.name }}</span>
      </span>
      <span
          v-if="index === 1"
          class="grey--text text-caption"
      >
          (+{{ value.length - 1 }} others)
        </span>
    </template>
  </v-select>
</template>

<script>
import VueTypes from "vue-types";
import {ProductGroupKind} from "@/modules/redactor/models/product/ProductGroupKind";

export default {
  name: "r-product-group-kind",
  props: {
    label: VueTypes.string.def("Product Group"),
    model: VueTypes.oneOfType([VueTypes.instanceOf(ProductGroupKind), VueTypes.arrayOf(String)]),
    multiple: VueTypes.bool.def(false),
    disabled: VueTypes.bool.def(false),
    clearable: VueTypes.bool.def(false)
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    items() {
      return ProductGroupKind.getValues();
    }
  }
}

</script>